module.exports = __webpack_public_path__ + "img/u1989_div.80acf936.png";